const { ApplyRulesButton } = require('apply-rules-button');

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.bk.applyRulesButton', deps)
  .directive('applyRulesButton', reactDirective => reactDirective(ApplyRulesButton));
